<template>
  <div id="app">
    <div class="container">
      <!-- 1st Row: Progress Bar (10% of screen height) -->
      <p id="success_message" v-if="taskComplete">
        You have successfully finished the task. Thank you for your time.
      </p>
      <div class="progress-container" id="progress-container-">
        <div class="progress-bar" :style="{ width: progressPercentage + '%' }">
          <!-- Display current image index out of total -->
        </div>
        <span class="progress-text"
          >{{ currentImageIndex + 1 }}/{{ images.length }}</span
        >
      </div>
      <!-- 2nd Row: Image with Prev/Next Buttons (50% of screen height) -->
      <div class="image-row">
        <button class="nav-button" @click="prevImage">◀</button>
        <img id="spiralImage" alt="Classified Image" class="main-image" />
        <button class="nav-button" @click="nextImage">▶</button>
      </div>

      <!-- 3rd Row: Classification Label and Selection (20% of screen height) -->
      <div class="classification-row">
        <div class="classification-row-item" id="classification-box">
          <label class="classification-label">Classification:</label>
          <div class="radio-group">
            <label class="radio-button">
              <input type="radio" v-model="selectedLabel" value="Control" />
              <span class="radio-label">Normal</span>
            </label>
          </div>

          <label class="radio-button">
            <input type="radio" v-model="selectedLabel" value="Parkinson" />
            <span class="radio-label">Parkinson</span>
          </label>
        </div>
        <div class="classification-row-item" id="confidencelevel-box">
          <div><label class="classification-label">Confidence:</label></div>
          <div>
            <div class="radio-group">
              <label class="radio-button">
                <input
                  type="radio"
                  v-model="confidenceLevel"
                  value="Not sure"
                />
                <span class="radio-label">Not Sure</span>
              </label>

              <label class="radio-button">
                <input type="radio" v-model="confidenceLevel" value="Sure" />
                <span class="radio-label">Sure</span>
              </label>

              <label class="radio-button">
                <input
                  type="radio"
                  v-model="confidenceLevel"
                  value="Strongly Sure"
                />
                <span class="radio-label">Strongly Sure</span>
              </label>
            </div>
          </div>
        </div>
      </div>

      <!-- 4th Row: Confidence Radio Buttons (20% of screen height) -->
      <!-- <div class="confidence-row"> -->
      <!-- Submit Button -->
      <div class="submit-row">
        <button
          @click="submitClassification"
          id="submitBTN"
          class="submit-button"
        >
          Submit
        </button>
      </div>
      <!-- </div> -->
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      images: [], // Images from the backend API
      currentImageIndex: 0, // Index for navigation
      taskComplete: false,
      submit: false,
      selectedLabel: "", // Classification label
      confidenceLevel: "", // Selected confidence level
      doctorName: localStorage.getItem("userName"), // Get the doctor name from session storage
      classificationId: null, // Store the classification ID if it exists
      progressPercentage: 0,
      siteUrl: "https://handwriting.cognitivetests.ir/",
    };
  },
  mounted() {
    window.addEventListener("onbeforeunload", this.send_data_to_server());
    if (!localStorage.getItem("userName")) {
      this.$router.push("/");
    }
    this.fetchData();
  },
  beforeDestroy() {
    window.removeEventListener("onbeforeunload", this.send_data_to_server());
  },
  methods: {
    reset_data() {
      this.selectedLabel = "";
      this.confidenceLevel = "";
      this.submit = false;
      const Element = document.getElementById("submitBTN");
      Element.style.backgroundColor = "#020f47";
      this.checkExistingClassification();
    },
    setImages() {
      const imgElement = document.getElementById("spiralImage");
      imgElement.src = this.images[this.currentImageIndex];
      this.checkAllClassificationsComplete();
      this.updateProgress(); // Update the progress bar
    },
    updateProgress() {
      if (this.images.length > 0) {
        this.progressPercentage =
          ((this.currentImageIndex + 1) / this.images.length) * 100;
      }
    },
    async fetchData() {
      try {
        // Fetch the JSON file from the public directory
        const response = await fetch("./metadata.json");

        // Check if the response is ok (status 200-299)
        if (response.ok) {
          const data = await response.json();
          this.metaData = data; // Store the JSON data in the component
          this.images = this.metaData.map((item) => item.path[0]);
          this.initImage();
          // this.checkExistingClassification();
          this.setImages();
        } else {
          console.error("Failed to fetch data:", response.status);
        }
      } catch (error) {
        console.error("Error loading JSON:", error);
      }
    },
    prevImage() {
      if (this.currentImageIndex > 0) {
        this.currentImageIndex--;
        this.setImages();
        this.reset_data();
      }
    },
    nextImage() {
      if (!this.submit && (!this.selectedLabel || !this.confidenceLevel)) {
        const Element = document.getElementById("submitBTN");
        Element.style.backgroundColor = "lightcoral";
      } else if (this.currentImageIndex < this.images.length - 1) {
        this.currentImageIndex++;
        this.setImages();
        this.reset_data();
      } else {
        this.send_data_to_server();
      }
    },
    setConfidence(level) {
      this.confidenceLevel = level;
    },
    initImage() {
      if (!this.doctorName) {
        this.$router.push("/");
      }
      const classifications =
        JSON.parse(localStorage.getItem("classifications")) || [];

      // Find the first image without a classification
      let unclassifiedImage = null;
      for (let i = 0; i < this.images.length; i++) {
        const image = this.images[i];
        const existingClassification = classifications.find(
          (item) => item.image_name === image
        );

        if (!existingClassification) {
          unclassifiedImage = image;
          this.currentImageIndex = i; // Set the index for this unclassified image
          break;
        }
      }

      if (unclassifiedImage) {
        this.selectedLabel = null;
        this.confidenceLevel = null;
      }
    },
    checkExistingClassification() {
      if (!this.doctorName) {
        this.$router.push("/");
      }
      const currentImage = this.images[this.currentImageIndex];

      const classifications =
        JSON.parse(localStorage.getItem("classifications")) || [];

      // Find the classification for the current image
      const existingClassification = classifications.find(
        (item) => item.image_name === currentImage
      );

      if (existingClassification) {
        // Set the selected label and confidence level from the existing classification
        this.selectedLabel = existingClassification.label;
        this.confidenceLevel = existingClassification.confidence_level;
      } else {
        // Reset to default if no classification exists for the current image
        this.selectedLabel = null;
        this.confidenceLevel = null;
      }
    },
    submitClassification() {
      // Validation check before submitting
      if (!this.selectedLabel) {
        // alert("Please select a classification.");
        const Element = document.getElementById("classification-box");
        Element.style.border = "5px solid red";
        Element.style.borderRadius = "15px";
        Element.style.backgroundColor = "lightcoral";

        // console.log(Element);

        return;
      } else {
        const Element = document.getElementById("classification-box");
        Element.style.border = "0px";
        Element.style.backgroundColor = "white";
      }
      if (!this.confidenceLevel) {
        // alert("Please select a confidence level.");
        const Element = document.getElementById("confidencelevel-box");
        Element.style.border = "5px solid red";
        Element.style.borderRadius = "15px";
        Element.style.backgroundColor = "lightcoral";

        return;
      } else {
        const Element = document.getElementById("confidencelevel-box");
        Element.style.border = "0px";
        Element.style.backgroundColor = "white";
      }
      if (!this.doctorName) {
        this.$router.push("/");
      }
      this.submit = true;
      const data = {
        image_name: this.images[this.currentImageIndex], // Current image URL
        label: this.selectedLabel, // Selected label (Control/Parkinson)
        confidence_level: this.confidenceLevel, // Selected confidence level
        doctor_name: this.doctorName, // Doctor's name from session storage
      };

      let classifications =
        JSON.parse(localStorage.getItem("classifications")) || [];

      // Check if a classification for this image already exists
      const existingIndex = classifications.findIndex(
        (item) => item.image_name === data.image_name
      );

      if (existingIndex !== -1) {
        // Update the existing classification
        classifications[existingIndex] = data;
      } else {
        // Add new classification
        classifications.push(data);
      }

      // Save updated classifications back to sessionStorage
      localStorage.setItem("classifications", JSON.stringify(classifications));
      this.send_item_to_server(data);
      this.checkAllClassificationsComplete();

      this.nextImage();
    },
    send_data_to_server() {
      const classifications =
        JSON.parse(localStorage.getItem("classifications")) || [];

      if (classifications.length === 0) {
        console.log("No classifications data available to send.");
        return;
      }
      const data = {
        username: this.doctorName,
        classifications: classifications,
      };
      // console.log(data);

      fetch(this.siteUrl + "save_classification.php", {
        method: "POST",

        headers: {
          "Content-Type": "application/json",
        },

        body: JSON.stringify(data),
      })
        .then((response) => response.json())

        .then((data) => {
          console.log("Success");
        })

        .catch((error) => {
          console.error("Error:", error);
          const element = document.getElementById("progress-container-");
          const errorMessage = document.createElement("p");
          errorMessage.textContent = "Failed to connect to the server.";
          errorMessage.id = "error_message";
          element.before(errorMessage);
        });
    },
    async send_item_to_server(item) {
      const data = {
        username: this.doctorName,
        classifications: item,
      };
      // console.log(data);
      fetch(this.siteUrl + "save_classification.php", {
        method: "POST",

        headers: {
          "Content-Type": "application/json",
        },

        body: JSON.stringify(data),
      })
        .then((response) => {
          console.log("Success:", response.json());

          response.json();
        })

        .then((data) => {
          console.log("Success:");
          // console.log("Success:", data);
        })

        .catch((error) => {
          console.error("Error:", error);
          const element = document.getElementById("progress-container-");
          const errorMessage = document.createElement("p");
          errorMessage.textContent = "Failed to connect to the server.";
          errorMessage.id = "error_message";
          element.before(errorMessage);
        });
    },
    checkAllClassificationsComplete() {
      const classifications =
        JSON.parse(localStorage.getItem("classifications")) || [];

      // Check if there is a classification for each image
      const allClassified = this.images.every((image) =>
        classifications.some((item) => item.image_name === image)
      );

      if (allClassified) {
        this.taskComplete = true;
        // // All images are classified
        // // this.currentImageIndex = this.images.length; // Set index to indicate completion
        // const element = document.getElementById("progress-container-");
        // const successMessage = document.createElement("p");
        // successMessage.textContent =
        //   "You have successfully finished the task. Thank you for your time.";
        // successMessage.id = "success_message";
        // element.before(successMessage);
      }
    },
  },
};
</script>

<style>
html,
body {
  height: 100%;
  margin: 0;
  padding: 0;

  /* overflow: hidden; Prevent scrolling */
}

#app {
  height: 100%;
}
#success_message {
  color: rgb(12, 65, 8);
  font-weight: bold;
  height: 15px;
  padding: 8px 0;
  margin: 0;
  width: 100%;
  text-align: center;
}
#error_message {
  color: red;
  font-weight: bold;
  height: 10px;
  padding: 0;
  margin: 0;
  width: 100%;
  text-align: center;
}
.container {
  position: absolute;
  top: 0px;
  left: 0px;
  z-index: 10; /*This must be the highest z-index value of your page to be above all*/
  width: 100%;
  height: 100%;
  padding: 0; /* No padding */
  margin: 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
/* 1st Row: Instruction (10% of viewport height) */
.progress-container {
  width: 100%;
  height: 4%; /* Increase the height to make it more visible */
  min-height: 20px; /* Ensure a minimum height */
  background-color: #e0e0e0;
  border-radius: 5px;
  margin-top: 10px;
  position: relative;
  text-align: center;
}

.progress-bar {
  height: 100%;
  background-color: #020f47;
  width: 0%;
  border-radius: 5px;
  transition: width 0.3s;
  position: relative;
}
.progress-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #ffffff;
  font-weight: bolder;
}
/* 2nd Row: Image with Buttons (50% of viewport height) */
.image-row {
  flex: 0 0 70%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #ffffff;
  padding: 0;
  margin: 0;
  align-items: center;
}

.main-image {
  /* max-height: auto;
 */
  max-height: 50%;

  max-width: 40%;
  object-fit: contain;
  padding: 0;
  margin: 0;
}

.nav-button {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #020f47;
  color: white;
  border-radius: 50%;
  border: none;
  padding: 10px 10px;
  width: 40px;
  height: 40px;
  font-size: 1.2rem;
  cursor: pointer;
}

.nav-button:hover {
  background-color: #020f47;
}

/* 3rd Row: Classification (20% of viewport height) */
.classification-row {
  flex-direction: row;
  flex: 0 0 5%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5%;
  background-color: #ffffff;
  border: 2px;
  border-color: #020f479f;
}
.classification-row-item {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  /* margin-right: 5%; */
}

.classification-label,
.confidence-label {
  font-size: 1.1rem;
  font-weight: bold;
  margin-right: 10px;
  margin-top: 0px;
  /* transform: translateY(-50%); */
  /* margin: 0; */
}

.radio-group {
  display: flex;
  gap: 20px;
  /* margin-top: 10px; */
}

.radio-button {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.radio-label {
  margin-left: 10px;
}

input[type="radio"] {
  appearance: none;
  border: 2px solid #4caf50;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  cursor: pointer;
  position: relative;
  outline: none;
}

input[type="radio"]:checked {
  background-color: #4caf50;
  border-color: #4caf50;
  box-shadow: inset 0 0 0 4px white;
}

/* 4th Row: Confidence Buttons (20% of viewport height) */
.confidence-row {
  flex: 0 0 5%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #ffffff;
  margin: 0;
}

.confidence-button {
  background-color: #28a745;
  color: white;
  border: none;
  font-size: 0.8rem;
  margin-right: 5px;
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.confidence-button:hover {
  background-color: #218838;
}
.submit-row {
  flex: 0 0 5%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #ffffff;
  margin: 0;
}
/* Add styles for the new Submit button if necessary */
.submit-button {
  background-color: #020f47;
  color: white;
  padding: 10px 40px;
  margin: 10px;
  border: none;
  font-size: 1rem;
  border-radius: 5px;
  cursor: pointer;
}

.submit-button:hover {
  background-color: #020f479f;
}
@media (max-height: 550px) {
  .classification-row {
    /* flex: 0 0 10%; Adjust height of classification row */
    height: 4%;
    flex: 0 0 0%;
    /* gap: 0; */
    padding: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #ffffff;
    margin: 0;
  }
  .radio-group {
    /* flex-direction: column; Stack radio buttons vertically */
    gap: 2px;
    margin: 0;
    padding: 0;
  }
  .classification-row-item {
    margin: 0;
    padding: 0;
    transform: translateY(-50%);
    font-size: 0.9em;

    /* border: 2px
     solid #28a745; */
  }
  .submit-button {
    padding: 2px 40px;
    margin: 0px;
    font-size: 0.3em;
  }
  .image-row {
    /* flex: 0 0 20%; Adjust height of image row */
    /* transform: translateY(-10%); */
  }
  .progress-container {
    height: 1%; /* Slightly increase height on smaller screens */
  }
}
@media (max-height: 700px) {
  .container {
    gap: 0;
  }
  .progress-container {
    height: 2%; /* Slightly increase height on smaller screens */
  }
  .image-row {
    /* flex: 0 0 20%; Adjust height of image row */
    height: 20%;
  }
  .classification-row,
  /* .confidence-row, */
  .sumbit-row {
    /* flex: 0 0 10%; Adjust height of classification row */
    height: 10%;
    /* gap: 0; */
  }
  .submit-button {
    padding: 5px 40px;
    margin: 10px;
    font-size: 1em;
  }
}
/* Responsive styles */
@media (max-width: 700px) {
  .main-image {
    max-width: 80%;
  }

  .nav-button {
    font-size: 1rem;
    padding: 8px 15px;
  }

  .classification-row {
    flex-direction: column; /* Stack items vertically */
    /* gap: 20px; */
    font-size: 1rem;
  }

  .classification-row-item {
    width: 100%; /* Make each item take full width */
    justify-content: center;
    /* margin: auto 0; */
    /* padding: auto 0; */
  }
  .classification-label,
  .confidence-label {
    margin: 0;
    font-size: 1em;
    /* margin-top: 8px; */
    /* margin: 0; */
  }

  .radio-group {
    /* flex-direction: column; Stack radio buttons vertically */
    gap: 2px;
  }
  /* .confidence-container {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  } */
}
</style>
